module.exports = __webpack_public_path__ + "68ade335a7ac237006cf829d86a892fe.jpg";